import {
  Default_getInstance2tu01uy631lll as Default_getInstance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isNumberiramasdbon0i as isNumber,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Unit_instanceat14thlj150z as Unit_instance,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  to2cs3ny02qtbcb as to,
  printStackTrace18lnx7a39cni as printStackTrace,
  lazy2hsh8ze7j6ikd as lazy,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_Deflate2a0lyute7oxjd as get_Deflate,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { getS32LE1pxm9wohin3g8 as getS32LE } from './korlibs-memory-root-korlibs-memory.mjs';
import { jsObjectr1r5ao37ef4f as jsObject } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class IWASMLib {}
function readBytes(pos, size) {
  throw NotImplementedError.je();
}
function writeBytes(pos, data) {
  throw NotImplementedError.je();
}
function invokeFunc(name, params) {
  throw NotImplementedError.je();
}
function invokeFuncInt(name, params) {
  var tmp = this.x53(name, params.slice());
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function invokeFuncUnit(name, params) {
  this.x53(name, params.slice());
}
function readInts(pos, size) {
  var bytes = this.v53(pos, imul(size, 4));
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = getS32LE(bytes, imul(tmp_1, 4));
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function allocBytes(size) {
  return this.y53('malloc', [size]);
}
function allocBytes_0(bytes) {
  // Inline function 'kotlin.also' call
  var this_0 = this.b54(bytes.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.wasm.IWASMLib.allocBytes.<anonymous>' call
  this.w53(this_0, bytes);
  return this_0;
}
function allocInts(size) {
  return this.b54(imul(size, 4));
}
function freeBytes(ptrs) {
  var inductionVariable = 0;
  var last = ptrs.length;
  while (inductionVariable < last) {
    var ptr = ptrs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    this.x53('free', [ptr]);
  }
}
class WASMLib {
  constructor(content) {
    this.u53_1 = new JSWASMLib(content);
  }
  v53(pos, size) {
    return this.u53_1.v53(pos, size);
  }
  w53(pos, data) {
    this.u53_1.w53(pos, data);
  }
  x53(name, params) {
    return this.u53_1.x53(name, params);
  }
  y53(name, params) {
    return this.u53_1.y53(name, params);
  }
  z53(name, params) {
    this.u53_1.z53(name, params);
  }
  a54(pos, size) {
    return this.u53_1.a54(pos, size);
  }
  b54(size) {
    return this.u53_1.b54(size);
  }
  c54(bytes) {
    return this.u53_1.c54(bytes);
  }
  d54(size) {
    return this.u53_1.d54(size);
  }
  e54(ptrs) {
    this.u53_1.e54(ptrs);
  }
  p6() {
    this.u53_1.p6();
  }
}
class Base64DeflateWASMLib extends WASMLib {
  constructor(content) {
    super(uncompress(Default_getInstance().gp(content), get_Deflate()));
  }
}
class BaseWASMLib {
  constructor(content) {
    this.f54_1 = content;
    this.g54_1 = null;
  }
  n1j() {
    return this.f54_1;
  }
  p6() {
  }
}
class JSWASMLib extends BaseWASMLib {
  constructor(content) {
    super(content);
    this.j54_1 = null;
    var tmp = this;
    tmp.k54_1 = lazy(JSWASMLib$mem$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.l54_1 = lazy(JSWASMLib$u8$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.m54_1 = lazy(JSWASMLib$dataView$delegate$lambda(this));
  }
  v53(pos, size) {
    var out = new Int8Array(size);
    var u8 = _get_u8__ndcayw(this);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = u8[pos + n | 0];
      }
       while (inductionVariable <= last);
    return out;
  }
  w53(pos, data) {
    var inductionVariable = 0;
    var last = data.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        _get_u8__ndcayw(this)[pos + n | 0] = data[n];
      }
       while (inductionVariable <= last);
  }
  x53(name, params) {
    var tmp0_elvis_lhs = _get_wasmExports__dbcjyi(this)[name];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't find export '" + name + "'";
      throw IllegalStateException.h5(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var export_0 = tmp;
    return export_0.apply(_get_wasmExports__dbcjyi(this), params);
  }
  p6() {
    super.p6();
  }
}
//endregion
function _get_wasmExports__dbcjyi($this) {
  if ($this.j54_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    try {
      var module_0 = new WebAssembly.Module(ensureNotNull($this.n1j()));
      var dummyFunc = JSWASMLib$_get_wasmExports_$lambda_zfsn0h;
      var imports = jsObject([to('env', jsObject([to('abort', dummyFunc), to('emscripten_notify_memory_growth', dummyFunc)])), to('wasi_snapshot_preview1', jsObject([to('proc_exit', dummyFunc), to('fd_close', dummyFunc), to('fd_write', dummyFunc), to('fd_seek', dummyFunc)]))]);
      tmp_0 = (new WebAssembly.Instance(module_0, imports)).exports;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.wasm.JSWASMLib.<get-wasmExports>.<anonymous>' call
    tmp.j54_1 = tmp_0;
  }
  return $this.j54_1;
}
function _get_mem__e6cqxo($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.k54_1;
  mem$factory();
  return this_0.w1();
}
function _get_u8__ndcayw($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.l54_1;
  u8$factory();
  return this_0.w1();
}
function JSWASMLib$_get_wasmExports_$lambda_zfsn0h() {
  console.log('proc_exit', arguments);
  return Unit_instance;
}
function JSWASMLib$mem$delegate$lambda(this$0) {
  return function () {
    return _get_wasmExports__dbcjyi(this$0).memory.buffer;
  };
}
function JSWASMLib$u8$delegate$lambda(this$0) {
  return function () {
    return new Uint8Array(_get_mem__e6cqxo(this$0));
  };
}
function JSWASMLib$dataView$delegate$lambda(this$0) {
  return function () {
    return new DataView(_get_mem__e6cqxo(this$0));
  };
}
function mem$factory() {
  return getPropertyCallableRef('mem', 1, KProperty1, function (receiver) {
    return _get_mem__e6cqxo(receiver);
  }, null);
}
function u8$factory() {
  return getPropertyCallableRef('u8', 1, KProperty1, function (receiver) {
    return _get_u8__ndcayw(receiver);
  }, null);
}
//region block: post-declaration
initMetadataForInterface(IWASMLib, 'IWASMLib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(WASMLib, 'WASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(Base64DeflateWASMLib, 'Base64DeflateWASMLib');
protoOf(BaseWASMLib).v53 = readBytes;
protoOf(BaseWASMLib).w53 = writeBytes;
protoOf(BaseWASMLib).x53 = invokeFunc;
protoOf(BaseWASMLib).y53 = invokeFuncInt;
protoOf(BaseWASMLib).z53 = invokeFuncUnit;
protoOf(BaseWASMLib).a54 = readInts;
protoOf(BaseWASMLib).b54 = allocBytes;
protoOf(BaseWASMLib).c54 = allocBytes_0;
protoOf(BaseWASMLib).d54 = allocInts;
protoOf(BaseWASMLib).e54 = freeBytes;
initMetadataForClass(BaseWASMLib, 'BaseWASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(JSWASMLib, 'JSWASMLib', VOID, VOID, [IWASMLib, BaseWASMLib]);
//endregion
//region block: exports
export {
  Base64DeflateWASMLib as Base64DeflateWASMLib1nkue0zm1qc0o,
};
//endregion
